import { Link, useParams } from "react-router-dom";
import methods from "../../services/utility";
// assets
import back from "../../assets/images/icons/arrow-right2.svg";
import UnderConstruction from "../public/underConstruction/UnderConstruction";
import house from "../../assets/images/icons/house-2.svg";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const WareHouse = () => {
  const { branchId, restaurantId } = useParams();

  return (
    <main className="col-md-9 col-lg-12 mx-md-auto vh-100">
      <div className="d-none d-lg-flex justify-content-start align-items-baseline mb-3">
        <Link to={`/sale/${branchId}`} className="link back-link">
          <span>
            <img src={back} className="" alt="return" />
          </span>
          بازگشت
        </Link>
      </div>
      <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
        <div className="d-md-flex justify-content-between align-items-baseline">
          <Link to="/dashboard" className="link back-link">
            <span>
              <img src={back} className="" alt="return" />
            </span>
          </Link>
          انبار
        </div>
        <p className="date">{methods.currentDate()}</p>
      </div>
      {/* <div className='saleheader d-none d-lg-block'>
        <p>انبار</p>
      </div>
      <UnderConstruction/> */}
      {/* <ul
        className="nav nav-underline my-3 flex-nowrap overflow-auto"
        id="wareHouseTabs"
      >
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 1 ? "active" : ""}`}
            id="tab1"
            onClick={() => tabClick(1)}
            data-bs-toggle="tab"
            href="#content1"
          >
            بخش سفارش ها
          </a>
        </li>
      </ul> */}
      <div className="warehouse-wrapper">
        <Tabs
          defaultActiveKey="1"
          id="uncontrolled-tab-example"
          className="mb-3 warhouse-tab"
        >
          <Tab eventKey="1" title="اطلاعات بایه انبار">
            <div className="row">
              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  {/* <span className="badge sidebar-badge rounded-pill badge-top-left">
                    دسته بندی انبار
                  </span> */}
                  <div className="card-body">
                    <Link
                      to={`/warehouse/${restaurantId}/${branchId}/createCategoryWarehouse`}
                    >
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        مدیریت گروه انبار
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="card branchcardtabs">
                  <img src={house} className="branchtabicon" alt="warehouse" />
                  {/* <span className="badge sidebar-badge rounded-pill badge-top-left">
                    دسته بندی انبار
                  </span> */}
                  <div className="card-body">
                    <Link
                      to={`/warehouse/${restaurantId}/${branchId}/createWarehouse`}
                    >
                      <button
                        type="submit"
                        className="btn custome-btn btn-link-purple w-100"
                        data-toggle="hover-effect"
                      >
                        مدیریت انبارها
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </main>
  );
};

export default WareHouse;
